import { TFunction } from "i18next";

import {
    CorporateBundle,
    MobileProcessorBundle,
    MobileRetailBundle,
    ProcessorBundle,
    SmbBundle,
} from "components/licenses/bundles";
import { CombinedTier, OldLicensingModelTier, TenantType } from "domain/tenants";

export function generateTenantTypeToTranslationMap(t: TFunction) {
    return new Map<TenantType, string>([
        ["INTERNAL", t("Common.internal")],
        ["CUSTOMER", t("Common.tenant")],
        ["CHANNEL", t("Common.channel")],
        ["CORPORATE", t("Common.corporate")],
        ["PROCESSOR", t("Common.processor")],
        ["SMB", t("Common.smb")],
        ["MOBILE_RETAIL", t("Common.mobileRetail")],
        ["MOBILE_PROCESSOR", t("Common.mobileProcessor")],
    ]);
}

export function generateTierToTranslationMap(t: TFunction) {
    return new Map<CombinedTier, string>([
        [OldLicensingModelTier.BASIC, t("AddCustomerForm.pricingTierDialog.header.basic")],
        [OldLicensingModelTier.STANDARD, t("AddCustomerForm.pricingTierDialog.header.standard")],
        [OldLicensingModelTier.ADVANCED, t("AddCustomerForm.pricingTierDialog.header.advanced")],
        [CorporateBundle.STARTER, t("AddCustomerForm.pricingTierDialog.header.starter")],
        [CorporateBundle.ESSENTIALS, t("AddCustomerForm.pricingTierDialog.header.essentials")],
        [CorporateBundle.POWER, t("AddCustomerForm.pricingTierDialog.header.power")],
        [CorporateBundle.ENTERPRISE, t("AddCustomerForm.pricingTierDialog.header.enterprise")],
        [ProcessorBundle.CORE, t("AddCustomerForm.pricingTierDialog.header.core")],
        [ProcessorBundle.PRO, t("AddCustomerForm.pricingTierDialog.header.pro")],
        [ProcessorBundle.PRO_SCALE, t("AddCustomerForm.pricingTierDialog.header.proScale")],
        [SmbBundle.SELECT_50, t("AddCustomerForm.pricingTierDialog.header.select50")],
        [SmbBundle.SELECT_100, t("AddCustomerForm.pricingTierDialog.header.select100")],
        [SmbBundle.SELECT_PLUS_250, t("AddCustomerForm.pricingTierDialog.header.selectPlus250")],
        [SmbBundle.SELECT_PLUS_500, t("AddCustomerForm.pricingTierDialog.header.selectPlus500")],
        [MobileRetailBundle.MOBILE_RETAIL_LITE, t("AddCustomerForm.pricingTierDialog.header.mobileRetailLite")],
        [MobileRetailBundle.MOBILE_RETAIL_PLUS, t("AddCustomerForm.pricingTierDialog.header.mobileRetailPlus")],
        [MobileRetailBundle.MOBILE_RETAIL_PRO, t("AddCustomerForm.pricingTierDialog.header.mobileRetailPro")],
        [
            MobileProcessorBundle.MOBILE_PROCESSOR_CORE,
            t("AddCustomerForm.pricingTierDialog.header.mobileProcessorCore"),
        ],
        [MobileProcessorBundle.MOBILE_PROCESSOR_PRO, t("AddCustomerForm.pricingTierDialog.header.mobileProcessorPro")],
        [
            MobileProcessorBundle.MOBILE_PROCESSOR_PRO_SCALE,
            t("AddCustomerForm.pricingTierDialog.header.mobileProcessorProScale"),
        ],
    ]);
}
